/**
 *
 *
 *
 *
 */
export function getActions(sheet: HTMLOcSheetV1Element | null): HTMLElement | null {
  return sheet?.querySelector("[slot=actions]") ?? null;
}

/**
 *
 *
 *
 *
 */
export function getHeader(sheet: HTMLOcSheetV1Element | null): HTMLElement | null {
  return sheet?.shadowRoot!.querySelector(".sheet__header") ?? null;
}

export function isElement(value: ChildNode): value is Element {
  return value.nodeType === value.ELEMENT_NODE;
}

/**
 *
 *
 *
 *
 *
 */
export function getContent(sheet: HTMLOcSheetV1Element | null): HTMLElement | null {
  const container = document.createElement("div");

  sheet?.childNodes.forEach((child) => {
    /*                                        */
    if (!isElement(child) || !child.getAttributeNode("slot")) {
      /*                                                      */
      /*                                                                */
      container.append(child.cloneNode(true));
    }
  });

  return container.children.length ? container : null;
}
